import { Relationship } from '@griply/types';

import { DocumentSnapshot } from '../types/firestore';
import { firebaseTimestampToDate } from './firebase-timestamp-to-date';

export const relationshipConverter = {
  fromFirestore: (snapshot: DocumentSnapshot): Relationship => {
    const data = snapshot.data() as Record<string, unknown>;
    data.id = snapshot.id;
    return {
      ...data,
      // A missing references array must not read as "no relationship doc" —
      // that would route tag writes onto the doc-creating set() path, which
      // overwrites fields a newer client may have written.
      references: Array.isArray(data.references) ? data.references : [],
      createdAt: firebaseTimestampToDate(data.createdAt as Date),
      updatedAt: firebaseTimestampToDate(data.updatedAt as Date),
    } as Relationship;
  },
  toFirestore: (relationship: Relationship) => relationship,
};
